module.exports = "/_next/static/images/8b649def2f189477223de8f7e84d9bc3-people-smile-at-home-md@1x.jpg.webp";